import $ from 'jquery';
import whatInput from 'what-input';
import slick from 'slick-carousel';
import shariff from 'shariff';

window.$ = $;

import Foundation from 'foundation-sites';

function add_required_asterisks()
{
	var select = $("select[name='art']");

	if (select.length > 0)
	{
		var fields = ['company', 'surname', 'forename', 'address', 'zip', 'city'];
		var form = select.closest('form');

		if (select.val() === "Gedrucktes Exemplar per Post")
		{
			form.find('label').each(function (index)
			{
				if ($.inArray($(this).attr('for'), fields) !== -1)
				{
					$(this).html($(this).html().concat('*'));
				}
			});
		}
		else
		{
			var fields_add = ['email'];

			form.find('label').each(function (index)
			{
				if ($.inArray($(this).attr('for'), fields) !== -1)
				{
					$(this).html($(this).html().replace('*', ''));
				}
				else if ($.inArray($(this).attr('for'), fields_add) !== -1)
				{
					$(this).html($(this).html().replace('*', ''));
					$(this).html($(this).html().concat('*'));
				}
			});
		}
	}
}

// document ready method
$(function ()
{

	$('.slider-banner').slick({
		autoplay: true,
		autoplaySpeed: 3000,
		adaptiveHeight: true,
		arrows: false,
		dots: true
	});

	$('.talents-slider-multipe-cover').slick({
		asNavFor: '.talents-slider-multipe',
		slidesToShow: 4,
		slidesToScroll: 4,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: true
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	$('.talents-slider-multipe').slick({
		asNavFor: '.talents-slider-multipe-cover',
		slidesToShow: 4,
		slidesToScroll: 4,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	$('.talents-slider').slick({
		speed: 4000,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true
	});

	$('.slider-description').slick({
		asNavFor: '.slider-gallery',
		speed: 3000
	});

	$('.slider-gallery').slick({
		asNavFor: '.slider-description',
		speed: 3000
	});

	$('.slider-readalso').slick({
		autoplay: true,
		autoplaySpeed: 8000,
		autoSpeed: 5000,
		adaptiveHeight: true
	});

	$('.good-practice-slider').slick({
		speed: 300,
		dots: false,
		slidesToShow: 4,
		slidesToScroll: 4,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					infinite: true,
				}
			},
			{
				breakpoint: 480,
				settings: "unslick"
			}
		]
	});


	var stHeight = $('.slider-readalso').height(),
		timeout = false, // holder for timeout id
		delay = 250; // delay after event is "complete" to run callback

	function refreshSlickHeight()
	{
		$('.slick-slide').css('height', stHeight + 'px');
	}

// window.resize event listener
	window.addEventListener('resize', function ()
	{
		// clear the timeout
		clearTimeout(timeout);
		// start timing for event "completion"
		timeout = setTimeout(refreshSlickHeight, delay);
	});


	//$('.js-eh').matchHeight(true);

	var $menutrigger = $('.menu-trigger'),
		$body = $('body');

	$menutrigger.click(function (e)
	{
		e.preventDefault();

		$body.toggleClass('menu-opened');
		$body.removeClass('search-opened');
	});


	var $searchtrigger = $('.search-trigger');

	$searchtrigger.click(function (e)
	{
		e.preventDefault();

		$body.toggleClass('search-opened');
		$body.removeClass('menu-opened');
		$('.search input').focus();
	});


	$('.mobile-menu .menu-item-has-children').prepend('<i class="toggler fa fa-arrow-circle-down" aria-hidden="true"></i>');
	$(document).on('click', '.mobile-menu .menu-item-has-children .toggler', function (e)
	{

		e.preventDefault();
		e.stopPropagation();

		if ($(this).is(".fa-arrow-circle-down"))
		{
			$(this).removeClass("fa-arrow-circle-down");
			$(this).addClass("fa-arrow-circle-up");
		}
		else
		{
			$(this).addClass("fa-arrow-circle-down");
			$(this).removeClass("fa-arrow-circle-up");
		}

		var $p = $(this).parent();

		if (!$p.hasClass('dropdown-opened'))
		{
			var h = 0;
			$p.find('> ul.sub-menu > li').each(function ()
			{
				h += $p.outerHeight(true);
			});
			$p.find('> ul.sub-menu').css({'height': h, 'opacity': 1, 'visibility': 'visible'});
			$p.addClass('dropdown-opened');
		}
		else
		{
			$p.find('> ul.sub-menu').css({'height': 0, 'opacity': 0, 'visibility': 'hidden'});
			$p.removeClass('dropdown-opened');
		}

	});

	$("blockquote").each(function ()
	{
		$(this).has('img').addClass('quoteWithImage clearfix');
	});

	$('a[href$=".pdf"]').attr('target', '_blank');
	$('a[href="javascript:gaOptout()"]').attr('href', 'javascript:__gaTrackerOptout()');


	add_required_asterisks();
	$("select[name='art']").on('change', function ()
	{
		add_required_asterisks();
	});
});